import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import { useEstimateStructure, useVisibilityModeCellClassName, ValueCell } from "@tools";

export const RateCell = observer((cellProps) => {
  const structure = useEstimateStructure();
  const { hideSummaryRate } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryRate);
  
  return <ValueCell
    colName={ SummaryColumns.RATE }
    useDynamicWidth
    className={className}
    { ...cellProps}
  />;
})